<script lang="ts">
    import type TikTokPostEntity from "@apps/tiktok/entities/TikTokPostEntity";

    import { ModalToken } from "@components/Modal/ModalManager";

    import TikTokPostPreview from "../components/TikTokPostPreview.svelte";
    import TikTokPostSkeleton from "../components/TikTokPostSkeleton.svelte";

    export let skeleton = false;
    export let skeletonPostsCount = 8;
    export let posts: TikTokPostEntity[];
    export let postModalToken: ModalToken<{ id: number }>;
</script>

<div class="gw-tt-listing-layout">
    {#if skeleton}
        {#each Array(skeletonPostsCount).fill(null) as _}
            <div class="gw-tt-listing-layout__post-wrapper">
                <TikTokPostSkeleton />
            </div>
        {/each}
    {:else}
        {#each posts as post (post.postId)}
            <div class="gw-tt-listing-layout__post-wrapper">
                <TikTokPostPreview {post} {postModalToken} />
            </div>
        {/each}
    {/if}
</div>

<style>
    .gw-tt-listing-layout {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(325px, 1fr));
        max-width: 100%;
    }

    .gw-tt-listing-layout__post-wrapper {
        margin: 5px;
    }
</style>
